<template>
    <gofix-card fullContent class="mb-0 pt-20">
        <b-col md="12">
            <b-row>
                <b-col md="3">
                    <b-row>
                        <b-col md="6">
                            <gofix-form-dropdown
                                label="Month"
                                :clearable="false"
                                :filterable="false"  
                                fullContent
                                :searchable="false"
                                :options="months"
                                vLabel="text"
                                :reduce="option => option.value"
                                v-model="month">
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-dropdown
                                label="Year"
                                :clearable="false"
                                :filterable="false" 
                                :searchable="false"
                                :options="years"
                                v-model="year">
                            </gofix-form-dropdown>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="5">
                    <b-row>
                        <b-col md="6">
                            <gofix-form-dropdown
                                v-bind:class="{'run-loading small-loading': loading}"
                                label="Supplier Contract"
                                vLabel="contract_title"
                                :filterable="false"
                                v-model="supplier_contract"
                                :options="supplier_contracts"
                                @search="searchSupplierContract">
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-dropdown
                                label="Property Type" 
                                :filterable="false"
                                :clearable="false"
                                :options="property_types" 
                                v-model="property_type"
                                required 
                                show-icon-required>
                            </gofix-form-dropdown>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="4">
                    <b-row>
                        <b-col md="12" class="text-center pt-15">
                            <gofix-button class="ml-2 mr-2" label="Export PDF" @click="exportReport()" :disabled="activeExportBtn == false"></gofix-button>
                            <gofix-button class="ml-2 mr-2" label="Export Excel" @click="exportExcel()" :disabled="activeExportBtn == false"></gofix-button>
                            <gofix-button class="ml-2 mr-2" label="Export Excel All" @click="exportExcelAll()" :disabled="activeExportBtnAll == false"></gofix-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-col>
        <hr/>
        <gofix-table :settings="tableConfig"
            :table-items="tableItems"
            @load-items="getTableData"
            ref="gofixTable">
            <template slot="gofix_table:average_score" slot-scope="row">
                {{ row.item.average_score !== null ? row.item.average_score : 0 | formatMoney(2, '') }}
            </template>
            <template slot="gofix_table:max_score" slot-scope="row">
                {{ row.item.max_score !== null ? row.item.max_score : 0 | formatMoney(2, '') }}
            </template>
            <!-- <template slot="gofix_table:bottom-row" slot-scope="row" v-if="tableItems.length">
                <td class="text-right" :key="i" v-for="(field, i) in row.data.fields">
                    <div class="total-header" v-if="field.key === 'property_name'">
                        <p class="mb-1 text-left">
                            <strong>Total</strong>
                        </p>
                    </div>
                    <div v-if="field.key === 'no_of_inspection'">
                        <p class="mb-1">{{ total_no_of_inspection }}</p>
                    </div>
                    <div v-if="field.key === 'average_score'">
                        <p class="mb-1">{{ total_average_score }}</p>
                    </div>
                    <div v-if="field.key === 'max_score'">
                        <p class="mb-1">{{ total_max_score }}</p>
                    </div>
                </td>
            </template> -->
        </gofix-table>
    </gofix-card>
</template>
<script>
import moment from 'moment';
export default {
    name: 'po-inspection',
    props: {
        propertyType: {
            type: String,
            default: '',
        },
        contract: {
            type: Object,
            default: () => null,
        }
    },
    data() {
        return {
            tableConfig:{
                name: 'table-po-inspection',
                controls:{
                    create: false,
                    update: false,
                    delete: false,
                    tableImport: false,
                    tableExport: false,
                    tableColumnSettings: false,
                    reload: false,
                    tablePagination: false,
                    tableFilter: false
                },
                filter: { },
                page: 1,
                limit: 100,
                sortColumn: "id",
                sortDirection: "asc",
                fields: [
                    {
                        key: 'property_name',
                        label: 'Division',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-left',
                        tdClass: 'text-left',
                        thStyle: "width: 400px",
                    },
                    {
                        key: 'officer_name',
                        label: 'Officer',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-left',
                        tdClass: 'text-left',
                        thStyle: "width: 300px",
                    },
                    {
                        key: 'no_of_inspection',
                        label: 'NO. of Inspection',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-right',
                        tdClass: 'text-right'
                    },
                    {
                        key: 'average_score',
                        label: 'Average Score',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-right',
                        tdClass: 'text-right'
                    },
                    {
                        key: 'max_score',
                        label: 'Max Score',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-right',
                        tdClass: 'text-right'
                    },
                    {
                        key: 'auto',
                        label: '',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    },
                ]
            },
            tableItems: [],
            supplier_contracts: [],
            supplier_contract: '',
            locations: [],
            location: '',
            property_types: ['Residential', 'Hawker Centre'],
            property_type: 'Residential',
            years: [],
            year: '',
            months: [],
            month: '',
            timer: null,
            activeExportBtn: false,
            activeSaveBtn: false,
            total_no_of_inspection: 0,
            total_average_score: 0,
            total_max_score: 0,
            loading: false,
            activeExportBtnAll: true,
        }
    },
    watch: {
        ClientContractID: function(val) {
            this.getSupplierContract(null, true);  
        },
        "supplier_contract": function(val) {
            this.$refs.gofixTable.reloadTableItems();
        },
        "location": function(val) {
            if(val){
                this.$refs.gofixTable.reloadTableItems();
            }
        },
        "property_type": function(val) {
           if(val){
                this.$refs.gofixTable.reloadTableItems();
            }
        },
        "month": function(val) {
            if(val){
                this.$refs.gofixTable.reloadTableItems();
            }
        },
        "year": function(val) {
            if(val){
                this.$refs.gofixTable.reloadTableItems();
            }
        },
    },
    created() {
        this.getInitData()
        
        let item = localStorage.getItem("ClientContractID");
        if(item) item = JSON.parse(item);

        if(
            (this.ClientContractID && this.ClientContractID.id && item) || (!this.ClientContractID || !this.ClientContractID.id) && !item
        ) this.getSupplierContract(null, true);
    },
    filters: {
        highlightNode(val, option_selected) {
            if(option_selected) {
                if(option_selected.name) {
                    val = val.replace(option_selected.name, `<span class="d-inline font-weight-bold">${option_selected.name}</span>`);
                } else {
                    let regex = new RegExp(option_selected, "i");
                    let index = val.search(regex);
                    let substr = val.substr(index, option_selected.length);
                    val = val.replace(regex, `<span class="d-inline font-weight-bold">${substr}</span>`);
                }
            }

            return val;
        }
    },
    methods: {
        async getTableData(callback) {
            const { tableRequest , resolve,reject } = await callback();
            
            if ( !this.supplier_contract ) {
                this.activeExportBtn = false
                const response = {
                    items: [],
                    total: 0
                }
                resolve(response);
                this.tableItems = response.items;
                this.tableConfig.total = response.total;
                return;
            }

            tableRequest.month = this.month
            tableRequest.year = this.year
            tableRequest.contract_id = this.supplier_contract.id
            tableRequest.property_type = this.property_type
            tableRequest.type = 'inspection by po'
            
            await this.$store.dispatch("PAConservancyController/getPAReport", tableRequest)
            .then(response => {
                this.tableItems = response.items;
                this.tableConfig.total = response.total;

                this.total_no_of_inspection =  response.total_no_of_inspection
                this.total_average_score =  response.total_average_score
                this.total_max_score =  response.total_max_score

                resolve(response);

                if(this.tableConfig.total != 0){
                    this.activeExportBtn = true
                }else{
                    this.activeExportBtn = false
                }

                this.activeSaveBtn = false
            })
            .catch(err => { })
        },
        getInitData(){
            this.loadingData = true;
            var iYear = parseInt(moment().format('YYYY'));
            if(this.Year) this.year = this.Year;
            else this.year = iYear;
            
            for(var i=0;i<15;i++){
                this.years.push(iYear);
                iYear--;
            }
            this.month = moment().format('MM');
            this.populateMonthHeaders();
        },
        populateMonthHeaders(){
            var mTime = moment(this.year+"-"+"January"+"-"+"01","YYYY-MMMM-DD");
            var iMonth = 0;
            var iMonths = [];
            while(iMonth<12){
                var dTime = mTime.clone();
                dTime.add(iMonth,'month');
                iMonths.push({'text' : dTime.format('MMMM'), 'value' : dTime.format('MM')});
                iMonth++;
            }
            this.months = iMonths;
        },
        async getSupplierContract(search = null, is_set_default = false) {
            this.loading = true
            let tableRequest = {
                filter: {
                    contract_title: { type: "text", value: search, function: "ilike", with: [] },
                    contract_id: this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : ""
                },
                limit: 100,
                page: 1,
                isCMS: 1,
                useDatabaseView: true,
                sortColumn: "contract_title",
                sortDirection: "ASC"
            }
            await this.$store.dispatch("ContractController/getListSContracts", tableRequest)
            .then(response => {
                this.supplier_contracts = response.data.data.contracts
                if(is_set_default) {
                    this.supplier_contract = null
                    if(response.data.data.contracts[0]){
                        this.supplier_contract = response.data.data.contracts[0]
                    }
                }
                
                this.loading = false
            })
            .catch(err => {
                this.loading = false
            })
        },
        searchSupplierContract(search, loading){
            loading(true);
            this.supplier_contracts = []
            if(this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(async () => {
                try {
                    await this.getSupplierContract(search);
                    await loading(false);
                } catch (err) {
                    loading(false);
                }
            }, 500);
        },
        async exportReport() {

            let newData = this.tableItems.map(function(item) {
                return {
                    location_id: item.location_id,
                    adjust: item.adjust
                }
            });

            let totalPercent = 0

            newData.map(item => {
                item.adjust = this.$accounting.unformat(item.adjust)
                totalPercent = totalPercent + item.adjust
            })
            
            let getNewParam = {
                month: this.month,
                year: this.year,
                contract_id: this.supplier_contract.id,
                property_type: this.property_type,
                type: 'inspection by po',
                is_download_pdf: true,
                location_adjusts: newData
            };

            await this.$store.dispatch("PAConservancyController/exportInterimReportReport", getNewParam)
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'po-inspection-' + this.month + '-' + this.year + '.pdf');
                document.body.appendChild(link);
                link.click();
            })
            .catch(err => { })
        },
        async exportExcel() {
            
            let getNewParam = {
                month: this.month,
                year: this.year,
                contract_id: this.supplier_contract.id,
                property_type: this.property_type,
                type: 'inspection by po',
            };

            await this.$store.dispatch("PAConservancyController/exportInterimReportExcel", getNewParam)
            .then(response => {
                let nameFile = 'PO Inspection.xlsx';
                if(response.headers["content-disposition"]) {
                  let arrTemp = response.headers["content-disposition"].split("filename=");
                  if(arrTemp[1]) {
                    nameFile = arrTemp[1].replaceAll('"', "");
                  }
                }

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', nameFile);
                document.body.appendChild(link);
                link.click();
            })
            .catch(err => { })
        },

        async exportExcelAll() {

            if(this.ClientContractID && this.ClientContractID.id) {
                
                this.activeExportBtnAll = false;
                
                let getNewParam = {
                    month             : this.month,
                    year              : this.year,
                    contract_id       : this.supplier_contract && this.supplier_contract.id ? this.supplier_contract.id : null,
                    property_type     : this.property_type,
                    type              : 'inspection by po',
                    client_contract_id: this.ClientContractID.id,
                };

                await this.$store.dispatch("PAConservancyController/exportInterimReportExcel", getNewParam)
                .then(response => {
                    this.activeExportBtnAll = true;
                    if(response.headers && response.headers["content-disposition"]) {
                        let nameFile = 'PA-Conservancy.zip';
                        if(response.headers["content-disposition"]) {
                          let arrTemp = response.headers["content-disposition"].split("filename=");
                          if(arrTemp[1]) {
                            nameFile = arrTemp[1].replaceAll('"', "");
                          }
                        }

                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', nameFile);
                        document.body.appendChild(link);
                        link.click();
                    } else {
                        return this.$alertNotification("Data is empty, please try again.", "danger");
                    }
                })
                .catch(err => { this.activeExportBtnAll = true; })
            } else {
                return this.$alertNotification("Please select a contract.", "danger");
            }
            
        },
    }
}
</script>